"use client"

import type { ReactNode } from "react"
import { PublicPageNav } from "@/components/public-page-nav"

/**
 * The /listings chrome: public nav for logged-out visitors, nothing extra for
 * signed-in ones (their chrome is global). A client component, so it lives
 * here and app/[locale]/listings/layout.tsx stays a server component that can
 * export metadata.
 */
export function ListingsShell({ children }: { children: ReactNode }) {
  // Children always render, on the server too. This used to return a
  // full-page loader until a client-side auth check finished, which meant the
  // server HTML for /listings and every /listings/[id] was a spinner:
  // crawlers that don't run JS (most AI answer engines) saw a title and
  // nothing else — no shop, no plans, no structured data. PublicPageNav owns
  // that check now, and the nav is fixed-position, so it resolving a beat
  // later moves nothing on the page.
  //
  // Signed-in visitors get nothing here: their chrome is globally mounted in
  // app/layout.tsx — FloatingNav (bottom-centre launcher), BrandHeader
  // (top-centre wordmark), DesktopNotificationsHeader (top-right bell).
  return (
    <div className="min-h-screen text-gray-900">
      <PublicPageNav audience="barber" />
      <main>{children}</main>
    </div>
  )
}
